import ImageClassification from './image-classification.svelte';
import ObjectDetection from './object-detection.svelte';
import Onnx from './onnx.svelte';
import PyTorch from './pytorch.svelte';
import TensorFlow from './tensorflow.svelte';

export default {
  ImageClassification,
  ObjectDetection,
  Onnx,
  PyTorch,
  TensorFlow,
};
